export default __webpack_public_path__ + "81a5de5a23d107075467aa5de5893d82.png";